module.exports = __webpack_public_path__ + "static/media/sidebar.71f050e7.png";